import App from './App.svelte';
import './alpine.js';
import './swiper.js';

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

console.log({
	site: window.siteData,
	intro: window.introData,
	posts: window.postsData,
	single: window.singlePost,
});

const app = new App({
	target: document.getElementById('svelte'),
	props: {
		site: window.siteData,
		intro: window.introData,
		posts: window.postsData,
		single: window.singlePost,
	}
});

export default app;